import React from "react";

// Skill color mapping (must match tailwind.config.js keys)
const skillColors = {
  criticalThinking: {
    border: "border-skillColor-criticalThinkingBorder",
    bg: "bg-skillColor-criticalThinking",
    text: "text-[#22333B]"
  },
  adaptability: {
    border: "border-skillColor-adaptabilityBorder",
    bg: "bg-skillColor-adaptability",
    text: "text-[#22333B]"
  },
  collaboration: {
    border: "border-skillColor-collaborationBorder",
    bg: "bg-skillColor-collaboration",
    text: "text-[#22333B]"
  },
  communication: {
    border: "border-skillColor-communicationBorder",
    bg: "bg-skillColor-communication",
    text: "text-[#22333B]"
  },
  learnersMindset: {
    border: "border-skillColor-learnersMindsetBorder",
    bg: "bg-skillColor-learnersMindset",
    text: "text-[#22333B]"
  },
  personalResponsibility: {
    border: "border-skillColor-personalResponsibilityBorder",
    bg: "bg-skillColor-personalResponsibility",
    text: "text-[#22333B]"
  },
  empathy: {
    border: "border-skillColor-empathyBorder",  
    bg: "bg-skillColor-empathy",
    text: "text-[#22333B]"
   }
};

export function SkillBadge({ name }) {
  // Convert display name to config key
  const key = name
    .replace(/\s+/g, "")
    .replace(/([A-Z])/g, (m) => m.toLowerCase());
  const color = skillColors[key] || skillColors.criticalThinking;
  return (
    <div
      className={`px-4 h-[26px] rounded-[20px] border-[1px] ${color.border} ${color.bg} ${color.text} font-semibold text-[14px]`}
    >
      {name}
    </div>
  );
}

export default function SkillPill({ skills = [], message="Awaiting educator feedback", reviewed = false }) {
  return (
    <div className="flex gap-3 flex-wrap">
      {skills.length === 0 ? (
        <span className="text-sm text-gray-500">{reviewed ? "See educator feedback" : message}</span>
      ) : (
        skills.map((skill, idx) => (
          <SkillBadge key={idx} name={skill} />
        ))
      )}
    </div>
  );
}
